module.exports = __webpack_public_path__ + "img/pikantesalat-uncutted-background.76bb74cf.jpg";